import { Typography, Box, IconButton, useTheme } from "@mui/material"
import { tokens } from "../theme"
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined"
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined"

const Header = ({ title, subtitle, toggleColorMode }) => {
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb="30px">
      <Box>
        <Typography
          variant="h2"
          fontWeight="bold"
          sx={{
            m: "0 0 5px 0",
            background: theme.palette.mode === 'dark' 
              ? 'linear-gradient(135deg, #f3f4f3ff 0%, #cedcd3ff 100%)' 
              : 'linear-gradient(135deg, #1f2937 0%, #14532d 100%)',
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            letterSpacing: "-1px",
          }}
        >
          {title}
        </Typography>
        <Typography variant="h5" color={colors.grey[400]} fontWeight="500">
          {subtitle}
        </Typography>
      </Box>
      
      {/* Theme Toggle */}
      <IconButton onClick={toggleColorMode}>
        {theme.palette.mode === 'dark' ? (
          <DarkModeOutlinedIcon />
        ) : (
          <LightModeOutlinedIcon />
        )}
      </IconButton>
    </Box>
  )
}

export default Header
